import _pt from 'prop-types';
import React from 'react';
import { jsx } from '@emotion/core';
import { observer } from 'mobx-react';
import useStores from "../../hooks/useStores.js";
import FieldAssignmentTypeDropdown from "./FieldAssignmentTypeDropdown.js";
import AssignedToDropdown from "./AssignedToDropdown.js";
var assignmentLabelFor = {
  signature: 'Signed By',
  initials: 'Initialed By'
};

var FieldAssignmentDropdowns = function FieldAssignmentDropdowns(_ref) {
  var _pdfStore$selectedFie, _pdfStore$selectedFie2;

  var _ref$clearable = _ref.clearable,
      clearable = _ref$clearable === void 0 ? false : _ref$clearable;

  var _useStores = useStores(),
      pdfStore = _useStores.pdfStore;

  var dataType = (_pdfStore$selectedFie = pdfStore.selectedField) === null || _pdfStore$selectedFie === void 0 ? void 0 : _pdfStore$selectedFie.data.dataType;
  var valueType = (_pdfStore$selectedFie2 = pdfStore.selectedField) === null || _pdfStore$selectedFie2 === void 0 ? void 0 : _pdfStore$selectedFie2.data.valueType;
  if (!pdfStore.selectedField || dataType === 'autofill') return null;
  return jsx(React.Fragment, null, jsx(FieldAssignmentTypeDropdown, {
    label: assignmentLabelFor[valueType || ''] || 'Entered By'
  }), jsx(AssignedToDropdown, {
    clearable: clearable
  }));
};

FieldAssignmentDropdowns.propTypes = {
  clearable: _pt.bool,
  children: _pt.node
};
var FieldAssignmentDropdowns$1 = observer(FieldAssignmentDropdowns);
export default FieldAssignmentDropdowns$1;